import List from 'settings/roles/List'
import Create from 'settings/roles/Create'
import Edit from 'settings/roles/Edit'
export default {List, Create, Edit}
